module.exports = __webpack_public_path__ + "img/DK34631328.27d78cb5.png";